import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const kitchenApi = {
  getInstantRequirements: async (startDate: string, endDate: string, kitchenId: string) => {
    const response = await axios.get(`${API_URL}/api/admin/kitchen/requirements/instant`, {
      params: { startDate, endDate, kitchenId },
      headers: { Authorization: `Bearer ${localStorage.getItem("adminToken")}` },
    });
    return response.data;
  },
  getDailyRequirements: async (startDate: string, endDate: string, kitchenId?: string) => {
    const response = await axios.get(
      `${API_URL}/api/admin/kitchen/requirements?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}${kitchenId ? `&kitchenId=${encodeURIComponent(kitchenId)}` : ""}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );
    return response.data;
  },
};

export default kitchenApi;
